import Double11Year2020 from '@/views/year2020/double11'
export default {
    path: '/double11',
    name: 'Double11Year2020',
    component: Double11Year2020
}